import React, {useState, useEffect} from "react";
import { TextField, Checkbox, FormControlLabel, FormHelperText, Grid, Typography, Box, Container, Button, FormLabel, RadioGroup, Radio, FormGroup, FormControl, Dialog, DialogContent,DialogTitle, DialogActions } from "@mui/material";
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import api from "./api.js";
import Header from "./components/Header.jsx";
import { useConfirmBackLogout } from "./common/useConfirmBackLogout.js";
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import { useValidatedChangeWithError } from "./common/useValidatedChangeWithError.js";
import { decimalValidator } from "./common/validators.js";
import HamburgerMenu from "./components/Hamburger.jsx";

const Comp7Sub = ({exhibitorId: propExhibitorId, isModal=false, isCorpModal=false, setFormModalOpen, selectedFormKey, changeModalOpen, setExhibitors}) => {
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const [showFormMenu, setShowFormMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [notApply, setNotApply] = useState(false);
  const [sameAsInvoice, setSameAsInvoice] = useState("different");
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState({
    water: false,
    air: false,
    gas: false,
  });
  const [formData, setFormData] = useState({
    user_7_name: "",
    user_7_department: "",
    user_7_phone: "",
    user_7_tel: "",
    invoice_company_name: "",
    invoice_user_name: "",
    invoice_email: "",
    invoice_address: "",
    invoice_zip: "",
    invoice_tel: "",
    invoice_fax: "",
    water_using: "",
    water_quantity: 0,
    water_pipe: "",
    water_ex_pipe: null,
    air: "",
    gas: "",
    alfa_text: "",
  });

  const [errors, setErrors] = useState({});

  const handleValidatedChange = useValidatedChangeWithError(
    setFormData,
    setErrors
  );

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };


  const updateCorporateStatus = (exhibitorId, formType, action) => {
    setExhibitors((prev) =>
      prev.map((ex) => {
        if (ex.exhibitor_id !== exhibitorId) return ex;

        if (action === 'confirm') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '確認済',
            [`${formType}_host_status`]: '確認済',
          };
        }

        if (action === 'correction') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '未確認',
            [`${formType}_host_status`]: '未確認',
            [`${formType}_exhibitor_status`]: '再提出',
          };
        }

        return ex;
      })
    );
  };

  const handleCorrection = async () => {
    try {
      const res = await api.patch('/api/forms/correction', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'correction');

      alert('再提出に更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('再提出処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };

    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'confirm');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };

  useEffect(() => {
    if ((isModal || isCorpModal) && propExhibitorId) {
      setExhibitorId(propExhibitorId);
      return;
    }

    const userData = localStorage.getItem("user");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      if (parsedUser?.exhibitor_id) {
        setExhibitorId(parsedUser.exhibitor_id);
      } else {
        console.warn("exhibitor_id が見つかりません");
      }
    } else {
      console.warn("localStorageにuserが存在しません");
    }
  }, [location, isModal, isCorpModal, propExhibitorId]);


  const [sameAsExhibitor, setSameAsExhibitor] = useState("different");
  const handleCheckboxChange = (e) => {
    const { name, checked: isChecked } = e.target;

    setChecked((prev) => ({ ...prev, [name]: isChecked }));

    if (!isChecked) {
      setFormData((prev) => {
        let resetFields = {};

        if (name === "water") {
          resetFields = {
            water_using: "",
            water_quantity: null,
            water_pipe: "",
            water_ex_pipe: null,
          };
        }

        if (name === "air") {
          resetFields = {
            air: ""
          };
        }

        if (name === "gas") {
          resetFields = {
            gas: "",
          };
        }

        return { ...prev, ...resetFields };
      });
    }
  };


  const handleChange = (e) => {
    const { name, value, type } = e.target;
    const val = type === "number" ? Number(value) : value;
    setFormData(prev => ({ ...prev, [name]: val }));
  };

  const handleBooleanChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value === "true" }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const [invFieldsDisabled, setInvFieldsDisabled] = useState(false);

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_7_name: mypageData.user_name || "",
        user_7_department: mypageData.department || "",
        user_7_phone: mypageData.phone_number || "",
        user_7_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_7_name: "",
        user_7_department: "",
        user_7_phone: "",
        user_7_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };

  const handleSameAsInvoice = (value) => {
    setSameAsInvoice(value);

    if (value === "same") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: mypageData.company_name || "",
        invoice_user_name: mypageData.user_name || "",
        invoice_email: mypageData.email || "",
        invoice_address: mypageData.address || "",
        invoice_zip: mypageData.zip_code || "",
        invoice_tel: mypageData.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } else if (value === "different") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: "",
        invoice_user_name: "",
        invoice_email: "",
        invoice_address: "",
        invoice_zip: "",
        invoice_tel: "",
      }));
      setInvFieldsDisabled(false);
    }
  };

  const handleParentInvoiceClick = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/api/parent-invoice/${mypageData.representative_id}`);
      const data = res.data;
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: data.company_name || "",
        invoice_user_name: data.user_name || "",
        invoice_email: data.email || "",
        invoice_address: data.address || "",
        invoice_zip: data.zip_code || "",
        invoice_tel: data.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } catch (error) {
      console.error("親出展者の請求情報取得に失敗しました:", error);
      alert("親出展者の情報を取得できませんでした。");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchO7InitialData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));

        // 並列で2つAPI叩く
        const [resStatus, resO7, resMypage] = await Promise.all([
          api.get(`/api/submission-status/${exhibitorId}`),
          api.get(`/api/o7submission/${exhibitorId}`),
          api.get(`/api/mypage/${exhibitorId}`)
        ]);

        const o7Status = resStatus.data?.o7_status || "";
        const o7Data = resO7.data || {};
        const mypage = resMypage.data || {};

        if (o7Status === "申請しない") {
          setNotApply(true);
          setFormData({
            user_7_name: null,
            user_7_department: null,
            user_7_phone: null,
            user_7_tel: null,
            invoice_company_name: null,
            invoice_user_name: null,
            invoice_email: null,
            invoice_address: null,
            invoice_zip: null,
            invoice_tel: null,
            invoice_fax: null,
            water_using: null,
            water_quantity: null,
            water_pipe: null,
            water_ex_pipe: null,
            air: null,
            gas: null,
            alfa_text: null,
          });
        } else {
          if (Object.values(o7Data).some(v => {
            if (Array.isArray(v)) return v.length > 0;
            return v !== "" && v !== null && v !== undefined;
          })) {
            setFormData(prev => ({
              ...prev,
              ...o7Data,
            }));
            if (
              o7Data.user_7_name === mypage.user_name &&
              o7Data.user_7_department === mypage.department &&
              o7Data.user_7_phone === mypage.phone_number &&
              o7Data.user_7_tel === mypage.tel_number
            ) {
              setSameAsExhibitor("same");
              setFieldsDisabled(true);
            } else {
              setFieldsDisabled(false);
            }
            if (
                o7Data.invoice_company_name === mypage.company_name &&
                o7Data.invoice_user_name === mypage.user_name &&
                o7Data.invoice_email === mypage.email &&
                o7Data.invoice_address === mypage.address &&
                o7Data.invoice_tel === mypage.phone_number &&
                o7Data.invoice_zip === mypage.zip_code
            ) {
                setSameAsInvoice("same");
                setInvFieldsDisabled(true);
            } else {
                setInvFieldsDisabled(false);
            }
            const hasWater = o7Data.water_using || o7Data.water_quantity || o7Data.water_pipe || o7Data.water_ex_pipe;
            const hasAir = o7Data.air;
            const hasGas = o7Data.gas;

            setChecked({
            water: !!hasWater,
            air: !!hasAir,
            gas: !!hasGas,
            });
          }
          setNotApply(false);
        }

      } catch (err) {
        console.error("O7初期データ取得エラー:", err);
      }
    };

    fetchO7InitialData();
  }, []);

  const handleNoApplyChange = (checked) => {
      setNotApply(checked);

      if (checked) {
          setFormData({
            user_7_name: "",
            user_7_department: "",
            user_7_phone: "",
            user_7_tel: "",
            invoice_company_name: "",
            invoice_user_name: "",
            invoice_email: "",
            invoice_address: "",
            invoice_zip: "",
            invoice_tel: "",
            invoice_fax: "",
            water_using: null,
            water_quantity: null,
            water_pipe: null,
            water_ex_pipe: null,
            air: "",
            gas: null,
            alfa_text: null,
          });
      }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };  
  
    const [isHovered, setIsHovered] = useState(false);
  
    const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展概要(規定)', path: '/しんきんビジネスフェア2026出展概要_0709.pdf' },
      { label: '会場平面図', path: '/会場平面図.pdf' },
      { label: '荷物の発送について', path: '/荷物の発送について.pdf' },
      { label: 'お弁当について', path: '/お弁当について.pdf' },
      { label: '宿泊のご案内', path: '/宿泊のご案内.pdf' },
      { label: '来場者カード一覧', path: '/来場者カード一覧.pdf' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者申請システムログイン方法', path: '/出展社申請システムログイン方法.pdf' },
      // { label: '各種届出提出方法', path: '/各種届出提出方法.pdf' },
      // { label: '出展者証について', path: '/出展者証について.pdf' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];
  
    const renderMenuItems = () => (
      <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
      >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
          <div className="submenu">
              {pdfItems.map((item, index) => (
              <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
              </a>
              ))}
          </div>
          )}
      </div>
    );

    const [noticeModalOpen, setNoticeModalOpen] = useState(false);
    const [ submitErrors, setSubmitErrors] = useState({});

    const handleSubmit = async () => {
    try {
        if (!exhibitorId || typeof exhibitorId !== "number") {
        alert("exhibitorId が不正です");
        return;
        }

        const submitErrors = {};

        if (!notApply) {
          // 基本必須項目チェック
          if (!formData.user_7_name?.trim()) submitErrors.user_7_name = "入力してください";
          if (!formData.user_7_phone?.trim()) submitErrors.user_7_phone = "入力してください";
          if (!formData.user_7_tel?.trim()) submitErrors.user_7_tel = "入力してください";
          if (!formData.invoice_company_name?.trim()) submitErrors.invoice_company_name = "入力してください";
          if (!formData.invoice_user_name?.trim()) submitErrors.invoice_user_name = "入力してください";
          if (!formData.invoice_email?.trim()) submitErrors.invoice_email = "入力してください";
          if (!formData.invoice_address?.trim()) submitErrors.invoice_address = "入力してください";
          if (!formData.invoice_zip?.trim()) submitErrors.invoice_zip = "入力してください";
          if (!formData.invoice_tel?.trim()) submitErrors.invoice_tel = "入力してください";

          // checkedのいずれかがtrueであることをチェック
          if (!checked.water && !checked.air && !checked.gas) {
            submitErrors.checked = "いずれかの工事希望にチェックしてください";
          }
        }

        const fieldDisplayNames = {
          user_7_name: "担当者名",
          user_7_department: "担当部署",
          user_7_phone: "担当者携帯",
          user_7_tel: "担当者電話",
          invoice_company_name: "請求先会社名",
          invoice_user_name: "請求先担当者名",
          invoice_email: "請求先メールアドレス",
          invoice_address: "請求先住所",
          invoice_zip: "請求先郵便番号",
          invoice_tel: "請求先電話番号",
          checked: "工事希望",
        };

        // エラーあれば早期リターン
        if (Object.keys(submitErrors).length > 0) {
          setSubmitErrors(submitErrors);
          window.scrollTo({ top: 0, behavior: "smooth" });

          const errorMessages = Object.entries(submitErrors)
            .map(([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`)
            .join("\n");

          alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
          return;
        }

        const payload = {
            exhibitor_id: exhibitorId,
            formData: formData,
            notApply: notApply,
        };

        const res = await api.post("/api/submit-o7", payload);

        if (res.status === 200) {
          // モーダルを表示
          setNoticeModalOpen(true);
          alert("保存成功");
        } else {
          alert("保存失敗");
        }
      } catch (err) {
        console.error(err);
        alert("エラー");
      }
    };

  const handleCloseNotice = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    setNoticeModalOpen(false);
    setTimeout(() => {
      if (isModal) {
        setFormModalOpen(false);
      } else {
        if (user?.user_id === 0) {
          navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
        } else {
          navigate(`/mypage/${user?.mypage_id}`);
        }
      }
    }, 1000);
  };

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  const user = JSON.parse(localStorage.getItem("user"));
  return (
    <div>
      {!isCorpModal &&(
        <Header
          title="しんきんビジネスマッチング　ビジネスフェア2026 給排水・エア・ガス申請"
          companyName={mypageData?.company_name}
        />
      )}
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }}>
        {!isCorpModal &&(
         <>
        <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }} className="sm-none">
              <Box
               className={`menu-item`}
               onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #0071BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#0071bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://shinkin-tokai.sakura.ne.jp/files/polisy.pdf', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <HamburgerMenu />
        </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Box sx={{ position: 'fixed', width:'14%' }}>
              <Typography variant="h6" className="f-16">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
        <Typography variant="h6" sx={{ backgroundColor: '#fff', px: 1, width: '95%', margin: 'auto'}}>給排水・エア・ガス申込</Typography>
        <FormGroup sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
            <FormControlLabel
            control={<Checkbox checked={notApply} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
            label="申請しない"
            />

            {!notApply && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                担当者情報
                </Typography>
                <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                </FormControl>
                <Grid container spacing={2}>
                <Grid size={6}><TextField fullWidth label="氏名" name="user_7_name" value={formData.user_7_name} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_7_name} helperText={submitErrors.user_7_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="部署" name="user_7_department" value={formData.user_7_department} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_7_department} helperText={submitErrors.user_7_department} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_7_phone" value={formData.user_7_phone} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_7_phone} helperText={submitErrors.user_7_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_7_tel" value={formData.user_7_tel} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_7_tel} helperText={submitErrors.user_7_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                </Grid>
                <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

                <Typography variant="h6" gutterBottom>
                請求先情報
                </Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsInvoice} onChange={(e) => handleSameAsInvoice(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                {user?.co_exhibit && sameAsInvoice === "different" && (
                  <Button
                    variant="outlined"
                    onClick={handleParentInvoiceClick}
                    disabled={loading}
                    style={{ marginBottom: "16px" }}
                  >
                    親出展者に請求する
                  </Button>
                )}
                </FormControl>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求先会社名" value={formData.invoice_company_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_company_name: e.target.value })} error={!!submitErrors.invoice_company_name} helperText={submitErrors.invoice_company_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求担当者名" value={formData.invoice_user_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_user_name: e.target.value })} error={!!submitErrors.invoice_user_name} helperText={submitErrors.invoice_user_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={12}><TextField fullWidth label="請求先メールアドレス" value={formData.invoice_email} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_email: e.target.value })} error={!!submitErrors.invoice_email} helperText={submitErrors.invoice_email} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={6}><TextField fullWidth label="郵便番号" value={formData.invoice_zip} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_zip: e.target.value })} error={!!submitErrors.invoice_zip} helperText={submitErrors.invoice_zip} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={12}><TextField fullWidth label="請求先住所" value={formData.invoice_address} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_address: e.target.value })} error={!!submitErrors.invoice_address} helperText={submitErrors.invoice_address} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={6}><TextField fullWidth label="電話番号" value={formData.invoice_tel} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_tel: e.target.value })} error={!!submitErrors.invoice_tel} helperText={submitErrors.invoice_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={6}><TextField fullWidth label="FAX番号" value={formData.invoice_fax} onChange={(e) => setFormData({ ...formData, invoice_fax: e.target.value })} /></Grid>
                </Grid>

                <Typography variant="h6" gutterBottom>
                給排水・エア・ガス工事
                </Typography>
                <FormControl
                  required
                  error={!!submitErrors.water}   // エラー状態をここで反映
                  component="fieldset"
                  variant="standard"
                >
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="water"
                          checked={checked.water}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="給排水工事を希望する"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="air"
                          checked={checked.air}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="エア工事を希望する"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="gas"
                          checked={checked.gas}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="ガス工事を希望する"
                    />
                  </FormGroup>
                  {/* エラーメッセージはここに */}
                  <FormHelperText>
                    {submitErrors.water || submitErrors.air || submitErrors.gas}
                  </FormHelperText>
                </FormControl>

                {checked.water && (
                    <>
                    <Typography variant="subtitle1">給排水</Typography>
                    <TextField label="用途" name="water_using" value={formData.water_using} onChange={handleChange} fullWidth margin="normal" />
                    <TextField label="使用量（リットル/分）" name="water_quantity" onWheel={(e) => e.target.blur()} type="number" value={formData.water_quantity} onChange={handleValidatedChange("water_quantity",decimalValidator({ scale: 2, label: "使用量" }))} error={!!errors.water_quantity} helperText={errors.water_quantity} fullWidth margin="normal" />
                    <FormControl component="fieldset" margin="normal">
                        <FormLabel component="legend">給水管</FormLabel>
                        <RadioGroup row name="water_pipe" value={formData.water_pipe} onChange={handleChange}>
                        <FormControlLabel value="13mm" control={<Radio />} label="ビニール管13mm　93,500円（税込）　　　　　　　　　　" />
                        <FormControlLabel value="20mm" control={<Radio />} label="ビニール管20mm　99,000円（税込）　　　　　　　　　　" />
                        <FormControlLabel value="25mm" control={<Radio />} label="ビニール管25mm　104,500円（税込）　　　　　　　　　　" />
                        </RadioGroup>
                    </FormControl>

                    <FormControl component="fieldset" margin="normal">
                        <FormLabel component="legend">排水管</FormLabel>
                        <RadioGroup row name="water_ex_pipe" value={String(formData.water_ex_pipe)} onChange={handleBooleanChange}>
                        <FormControlLabel value="true" control={<Radio />} label="40mm" />
                        <FormControlLabel value="false" control={<Radio />} label="50mm" />
                        </RadioGroup>
                    </FormControl>
                    </>
                )}

                {checked.air && (
                    <>
                    <Typography variant="subtitle1">エア</Typography>
                    <Typography>希望する詳細内容をご入力ください。</Typography>
                    <TextField label="自由記述" name="air" value={formData.air} onChange={handleChange} fullWidth multiline rows={3} margin="normal" />
                    </>
                )}

                {checked.gas && (
                    <>
                    <Typography variant="subtitle1">ガス</Typography>
                    <Typography>希望する詳細内容をご入力ください。</Typography>
                    <TextField label="自由記述" name="gas" value={formData.gas} onChange={handleChange} fullWidth multiline rows={3} margin="normal" />
                    </>
                )}

                <Typography variant="h6">備考欄</Typography>
                <Typography color="error">※給排水・エア・ガス工事申込について補足事項等がある場合はコチラにご入力ください。</Typography>
                <TextField fullWidth multiline rows={7} label="備考" value={formData.alfa_text} onChange={(e) => setFormData({ ...formData, alfa_text: e.target.value })} />
            </Box>
            )}
        </FormGroup>
        <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
          <Typography>
            【上記入力内容についてのお問い合わせ先】<br />
            福動興業(株)　名古屋営業所<br />
            担当：庄司、菱田<br />
            TEL:052-452-7413<br />
            入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
            ※お急ぎの場合はお電話にてお問い合わせください。
          </Typography>
        </Box>
        </Container>
      </Container>
      {!isCorpModal &&(
        <>
        <Container sx={{textAlign: 'center'}}>
            <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
                提出する
            </Button>
        </Container>
        <Dialog open={noticeModalOpen} onClose={handleCloseNotice}>
          <DialogTitle>注意事項</DialogTitle>
          <DialogContent>
            <p>
              給排水・エア・ガス申込を申請する場合は、給排水・エア・ガスの引き出し位置を「ブース平面図」よりご提出ください。
            </p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseNotice} color="primary">
              閉じる
            </Button>
          </DialogActions>
        </Dialog>
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
       </>
      )}
      {!!changeModalOpen &&(
        <Box display="flex" justifyContent="center" gap={2} mt={2}>
          <Button
            variant="contained"
            onClick={handleCorrection}
            sx={{
              backgroundColor: "red",
              color: "white",
              "&:hover": {
                backgroundColor: "darkred",
              },
            }}
          >
          再提出
          </Button>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleConfirm}
          >
            完了
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => setFormModalOpen(false)}
          >
            中断
          </Button>
        </Box>
        )}
    </div>
  );
};

export default Comp7Sub;